import { BrandsCarouselQuery, BrandsCarouselQueryVariables } from '@/types';
import { gql, useQuery } from '@apollo/client';
import { useAuthenticatedUserContext } from '@/contexts/user-context';

export const GET_BRANDS_CAROUSEL_QUERY = gql`
  fragment BrandPageCarouselFields on brand_pages {
    brand_name
    carousel_module
    logo_image_url
    uuid
  }

  query BrandsCarousel($restaurantUUID: uuid!, $supplierUUID: uuid!) {
    getBrandsCarousel(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      brand_page {
        ...BrandPageCarouselFields
      }
    }
  }
`;

export const useGetBrandsCarousel = (skip: boolean) => {
  const {
    selectedRestaurantRelationship: { supplierUUID },
    selectedRestaurantUUID: restaurantUUID,
  } = useAuthenticatedUserContext();
  const { data } = useQuery<BrandsCarouselQuery, BrandsCarouselQueryVariables>(
    GET_BRANDS_CAROUSEL_QUERY,
    {
      skip,
      variables: {
        restaurantUUID,
        supplierUUID,
      },
    },
  );

  return (data?.getBrandsCarousel ?? []).filter((item) =>
    Boolean(item.brand_page?.carousel_module),
  );
};
